import React from 'react';
import './Settings.css';

function SLASettings({ onBack }) {
    return (
        <div className="settings-component-wrapper">
            <button className="back-button" onClick={onBack}>
                <span className="back-icon">←</span>
                <span>Back to HR Settings</span>
            </button>

            <div className="settings-component-content">
                <div className="settings-component-header">
                    <h1>⏱️ SLA Settings</h1>
                    <p>Set up SLA thresholds and notification rules</p>
                </div>

                <div className="settings-component-body">
                    <div className="settings-info-card">
                        <h3>SLA Configuration Features</h3>
                        <p>This section will allow you to:</p>
                        <ul>
                            <li>Define SLA response times</li>
                            <li>Set priority-based thresholds</li>
                            <li>Configure escalation rules</li>
                            <li>Manage notification triggers</li>
                        </ul>
                    </div>

                    <div className="settings-placeholder-message">
                        <span className="placeholder-icon">🚧</span>
                        <p>SLA Settings configuration coming soon...</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SLASettings;
